import * as React from "react";
import { yourNameEn } from "../util";
import { basicData } from "../data";
import { useLang } from "../lang";

const Footer: React.FC = () => {
  const { langEn } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="ftco-footer ftco-bg-dark footer">
      <div className="container pl-5">
        <div className="row" id="contact">
          <div className="col-md">
            <div className="ftco-footer-widget">
              <h2 className="ftco-heading-2 mb-2">{langEn ? "Contact" : "連絡先"}</h2>
              <div className="block-23 mb-3">
                <ul>
                  <li>
                    <span className="icon icon-envelope"></span>
                    <span className="text email">{basicData.email}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p>
              &copy;{year} {yourNameEn} | This template is made with{" "}
              <i className="icon-heart" aria-hidden="true"></i> by{" "}
              <a href="https://colorlib.com" target="_blank" rel="noreferrer">
                Colorlib
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
